import { useCallback, useContext, useEffect } from 'react';

import { useChatStore } from '../../controllers/chat-store/useChatStore';

import { BackBehaviorOverrideContext } from './BackBehaviorOverrideContext';

/** Clears {@link BackBehaviorOverride} when the active conversation id no longer matches the override. */
export const BackBehaviorClearWhenConversationChanges = (): null => {
	const { override, setOverride } = useContext(BackBehaviorOverrideContext);
	const [{ currentConversationId }] = useChatStore();

	const clearIfConversationChanged = useCallback(() => {
		if (override && currentConversationId !== override.conversationId) {
			setOverride(null);
		}
	}, [override, currentConversationId, setOverride]);

	useEffect(() => {
		clearIfConversationChanged();
	}, [clearIfConversationChanged]);

	return null;
};
